export const PaymentChannelOptions = [
  { label: "เงินสด", id: "เงินสด" },
  { label: "เงินโอน", id: "โอนผ่านธนาคาร" },
  { label: "เช็ค", id: "เช็ค" },
  // { label: "บัตรเครดิต", id: "บัตรเครดิต" },
];

export const PrefixOptions = ["นาย", "นาง", "นางสาว", "Mr.", "Mrs.", "Ms."];

export const CategoryProductOptions = [
  { label: "เครื่องประดับ", id: 1 },
  { label: "อิเล็กทรอนิกส์", id: 2 },
  { label: "ทองคำ", id: 3 },
  { label: "พระเครื่อง", id: 4 },
  { label: "แบรนด์เนม", id: 5 },
  { label: "นาฬิกา", id: 6 },
];
